import { render } from "./main-collection.vue?vue&type=template&id=e06d6964&scoped=true"
import script from "./main-collection.vue?vue&type=script&lang=js"
export * from "./main-collection.vue?vue&type=script&lang=js"

import "./main-collection.vue?vue&type=style&index=0&id=e06d6964&lang=css"
import "./main-collection.vue?vue&type=style&index=1&id=e06d6964&scoped=true&lang=css"

import exportComponent from "/Users/suniyl/Documents/work/shopify-projects/behno/behno-us-version-3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e06d6964"]])

export default __exports__